import { types as sdkTypes } from './sdkLoader';

const { Money } = sdkTypes;

const getVariantPriceAmount = priceVariant => {
  if (Number.isInteger(priceVariant?.priceInSubunits)) {
    return priceVariant.priceInSubunits;
  }

  if (Number.isInteger(priceVariant?.price?.amount)) {
    return priceVariant.price.amount;
  }

  if (Number.isInteger(priceVariant?.price)) {
    return priceVariant.price;
  }

  return null;
};

const getVariantPriceCurrency = (priceVariant, fallbackCurrency) => {
  return priceVariant?.price?.currency || fallbackCurrency || null;
};

export const getCheapestPriceVariant = (priceVariants = []) => {
  if (!Array.isArray(priceVariants) || priceVariants.length === 0) {
    return null;
  }

  return priceVariants.reduce((cheapest, current) => {
    const cheapestAmount = getVariantPriceAmount(cheapest);
    const currentAmount = getVariantPriceAmount(current);

    if (!Number.isInteger(currentAmount)) {
      return cheapest;
    }

    if (!Number.isInteger(cheapestAmount) || currentAmount < cheapestAmount) {
      return current;
    }

    return cheapest;
  }, null);
};

export const getListingDisplayPrice = (listing, fallbackCurrency) => {
  const { price, publicData } = listing?.attributes || {};
  const sessionPricing = publicData?.sessionPricing;

  if (Number.isInteger(sessionPricing?.minPriceInSubunits) && sessionPricing?.currency) {
    return new Money(sessionPricing.minPriceInSubunits, sessionPricing.currency);
  }

  if (Number.isInteger(sessionPricing?.minPrice) && sessionPricing?.currency) {
    return new Money(sessionPricing.minPrice, sessionPricing.currency);
  }

  if (price) {
    return price;
  }

  const cheapestVariant = getCheapestPriceVariant(publicData?.priceVariants);
  const cheapestVariantAmount = getVariantPriceAmount(cheapestVariant);
  const currency = getVariantPriceCurrency(cheapestVariant, price?.currency || fallbackCurrency);

  if (!Number.isInteger(cheapestVariantAmount) || !currency) {
    return null;
  }

  return new Money(cheapestVariantAmount, currency);
};
